import React from 'react'
import Slider from 'app/theme/slider'
import styles from './CaseStudySlider.module.css'
import { getResizedPhotoUrl } from 'app/utils/photos'

export default function CaseStudySlider(props) {
  if (props.photos.length < 1) {
    return null
  }

  return (
    <div>
      <Slider
        className="flex mx-auto mb-10"
          slidesToShow={1}
          slidesToScroll={1}
          arrows={false}
          dots={true}
          responsive={[{
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]}
        >
          {props.photos.map(photo => (
            <div key={photo.id}>
              <div className={['w-full bg-cover', styles.slide]} style={{ backgroundImage: `url(${getResizedPhotoUrl(photo, 1024, 1024)})` }}></div>
            </div>
          ))}
        </Slider>
    </div>
  )
}
